var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup58673(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_58673",
    "data-name": "Group 58673",
    transform: "translate(-20751.002 -3385)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4487",
    "data-name": "Ellipse 4487",
    cx: 48,
    cy: 48,
    r: 48,
    transform: "translate(20751.002 3385)",
    fill: "#d9e7f1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_55895",
    "data-name": "Group 55895",
    transform: "translate(-3.27 -1)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9138",
    "data-name": "Rectangle 9138",
    width: 25,
    height: 26,
    transform: "translate(20791.002 3419)",
    fill: "#005ca3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bulb",
    d: "M37.665,0H4.874A4.878,4.878,0,0,0,0,4.874V28.8a4.878,4.878,0,0,0,4.874,4.874H7.09V41.21a1.329,1.329,0,0,0,2.269.939l8.472-8.472H37.665A4.878,4.878,0,0,0,42.54,28.8V4.874A4.878,4.878,0,0,0,37.665,0ZM24.886,24.622A1.978,1.978,0,0,1,22.9,26.589H19.639A2.046,2.046,0,0,1,17.654,24.3v-.957h7.232Zm1.436-5.247a3.8,3.8,0,0,0-1.383,2.2h-7.32a3.333,3.333,0,0,0-1.294-2.109,7.835,7.835,0,0,1-3.031-6.381,8.016,8.016,0,0,1,7.852-7.763,7.915,7.915,0,0,1,5.176,14.056Z",
    transform: "translate(20781.002 3415)",
    fill: "#9fc2dc"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup58673);
export default __webpack_public_path__ + "static/media/group_58673.d003fdd3c6f463b1b258c14d7e6f3565.svg";
export { ForwardRef as ReactComponent };